var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthAfrica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27735_106995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68628 27.3135C-1.56209 21.0651 -1.56209 10.9345 4.68628 4.68604C4.68584 4.68672 13.9131 15.9998 13.9131 15.9998L4.68628 27.3135Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9132 16.0002L2.12216 8.03223C1.7566 8.66766 1.43423 9.33091 1.15723 10.0174L7.12654 16.0002L1.15741 21.9834C1.43416 22.6694 1.75623 23.3322 2.12154 23.9672L13.9132 16.0002Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8645 13.9131H13.9125L4.68603 4.68652C3.69178 5.68077 2.82796 6.80521 2.12196 8.03215L10.0744 16L2.12134 23.9669C2.82734 25.1941 3.69153 26.319 4.68603 27.3135L13.9125 18.087H31.8645C31.9534 17.4038 31.9999 16.7073 31.9999 16C31.9999 15.2927 31.9534 14.5962 31.8645 13.9131V13.9131Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25854 28.6922C8.95661 30.7661 12.3339 31.9999 15.9999 31.9999C23.3924 31.9999 29.6127 26.9861 31.4487 20.1738H14.777L6.25854 28.6922Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4487 11.8261C29.6127 5.01381 23.3924 0 15.9999 0C12.3339 0 8.95661 1.23381 6.25854 3.30769L14.7769 11.8261H31.4487Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27735_106995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/south-africa.8271e61773f473a02ac20868b7f23965.svg";
export { ForwardRef as ReactComponent };